import { z } from 'zod'

export const TextFormSchema = z.object({
    text: z.string().max(2048),
})
export type TextFormSchemaType = z.infer<typeof TextFormSchema>
